import React, { useEffect, useState } from 'react'
import { Col, Icon, Row, Input, Button, AutoComplete, Modal, Form } from 'antd'
import { navigate, useQueryParams } from 'hookrouter'
import { useMediaPredicate } from 'react-media-hook'
import * as appConstants from '../../Utilities/AppConstants'
import * as FietsenMintjensAPI from '../../../api/FietsenMintjensAPI'
import * as antd from 'antd'
import '../../Common/ModalForm/ModalForm.css'
// import debounce from 'lodash/debounce'
import _ from 'lodash'

import Container from '../Container/ContainerComponent'
import MenuBarDropDownComponent from './MenuBarDropDownComponent'
import HamburgerMenuComponent from './HamburgerMenuButton/HamburgerMenuButton'
import MenuItem from './MenuItem/MenuItem'
import ContactView from './ContactView/ContactView'

import AppStyle from '../../../App.module.scss'
import * as HeaderComponentStyle from './HeaderComponent.module.scss'
import './HeaderComponentStyle.css'
import ModalForm from '../ModalForm/ModalForm'
import FormItem from 'antd/lib/form/FormItem'
import ContactUsModalForm from '../ModalForm/ContactUsModalForm'

const { Option } = AutoComplete
const menuItems = [
  'E-Bikes',
  'Sportfietsen',
  'Stads- / Vrijetijdsfietsen',
  'Mountainbikes',
  'Accessoires',
]

export default function HeaderComponent() {
  const isSmallScreen = useMediaPredicate('(max-width: 948px)')
  const isSmallScreenForMobile = useMediaPredicate('(max-width: 410px)')
  const [publicInformation,setPublicInformation]=useState({})
  const [isDropdownVisible, setDropDownVisibility] = useState(false)
  const [activeKey, setActiveKey] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)
  const [contactViewVisible, setContactViewVisible] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState()
  const [dataSource, setDataSource] = useState([])
  const [, setQueryParams] = useQueryParams()
  const [modalVisible,setModalVisible]= useState(false)
  useEffect(() => {
    if (searchKeyword && searchKeyword.length > 2) {
      FietsenMintjensAPI.getSearchProducts(searchKeyword)
        .then(res => {
          if (!_.isEqual(dataSource, res.data)) setDataSource(res.data)
        })
        .catch(err => {
          console.log('error', err)
        })
    } else {
      if (dataSource.length > 0) setDataSource([])
    }
  }, [searchKeyword, dataSource])
  useEffect( ()=>{
   FietsenMintjensAPI.getPublicInformation().then(response=>{
     setPublicInformation(response.data[0])
 })
  },[])
  const handleHamburgerMenuBtnClick = () => {
    setMenuOpen(!menuOpen)
    setDropDownVisibility(false)
  }

  const handleContactIconClick = () => {
    setContactViewVisible(!contactViewVisible)
  }

  const handleMenuItemClick = item => {
    navigate(`/products/${item}`)
    setMenuOpen(!menuOpen)
  }

  function TriggerDropDownMenu(actvKey) {
    if (isDropdownVisible && actvKey !== activeKey) {
      setActiveKey(actvKey)
    } else {
      setDropDownVisibility(!isDropdownVisible)
      setActiveKey(actvKey)
    }
  }

  const handleDropDownMenuItemClick = (header, text) => {
    setDropDownVisibility(false)
    setQueryParams({ key: header, value: text }, true)
    navigate(`/products/${activeKey}`, false)
  }

  // const handleSearch = debounce(text => {
  //   setSearchKeyword(text)
  // }, 500)

  // const handleChange = value => {
  //   setSearchInputValue(value)
  // }

  const handleSearch = text => {
    setSearchKeyword(text)
  }
  const handleSelect = value => {
    setSearchKeyword(dataSource[value].name)
  }

  const handleAutoCompleteOptionClick = (id, category) => {
    let productType
    if (category.findIndex(el => el === 'accessoires') >= 0) {
      productType = 'Accessoires'
    } else if (category.findIndex(el => el === 'fietsen') >= 0) {
      productType = category[1].charAt(0) + category[1].slice(1)
    } else {
      productType = category[0]
    }
    navigate(`/products/${productType}/${id}`)
  }

  const handleSearchClick = () => {
    setQueryParams({ keyword: searchKeyword }, true)
     navigate(`/products/search`)
  }

  const renderOption = (item, index) => {
    return (
      <Option key={index} text={item.name}>
        <div
          onClick={() =>
            handleAutoCompleteOptionClick(item._id, item.categories)
          }
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {item.name}
        </div>
      </Option>
    )
  }

  function switchData() {
    let data = []
    switch (activeKey) {
      case appConstants.bikesCategories.eBike.id:
        data = [
          {
            header: 'Populaire E-bikes',
            filter: 'brand',
            data: [
              { text: 'Scott' },
              { text: 'Gazelle' },
              { text: 'Bizobike' },
              { text: 'Koga' },
              {text:'Bosch'},
              {text:'Das.O. E-Bike'}
            ],
          },
          {
            header: 'Snelheid',
            filter: 'speed',
            data: [{ text: '25 km/u' }, { text: '45 km/u' }],
          },
          {
            header: 'Gebruik',
            filter: 'usage',
            data: [
              { text: 'Woon-werk' },
              { text: 'Hobby' },
              { text: 'Pro' },
              { text: 'Vrije tijd' },
            ],
          },
        ]
        break
      case appConstants.bikesCategories.raceBike.id:
        data = [
          {
            header: 'Populaire Racefietsen',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Types Racefietsen',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Gebruik',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
        ]
        break
      case appConstants.bikesCategories.cityBike.id:
        data = [
          {
            header: 'Populaire Stads- / Vrijetijdsfietsen',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Types Stads- / Vrijetijdsfietsen',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Gebruik',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
        ]
        break
      case appConstants.bikesCategories.mountainBike.id:
        data = [
          {
            header: 'Populaire Mountainbikes',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Types Mountainbikes',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Gebruik',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
        ]
        break
      case appConstants.accessories:
        data = [
          {
            header: 'Populaire Accessoires',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Types Accessoires',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
          {
            header: 'Gebruik',
            data: [
              { text: 'Scott (20)' },
              { text: 'Gazelle (39)' },
              { text: 'Koga (12)' },
              { text: 'Stromer (15)' },
            ],
          },
        ]
        break
      default:
        data = [{ header: 'Not Found', data: [] }]
    }
    return data
  }

  return (
    <React.Fragment>
      <Container>
        <Row
          type="flex"
          justify="space-between"
          align="middle"
          style={{
            paddingTop: 20,
            paddingBottom: 20,
            paddingLeft: 10,
            paddingRight: 10,
          }}
          className={HeaderComponentStyle.contactRowWrapper}
        >
          <Col md={16} lg={12}>
            <div className={HeaderComponentStyle.contactInformation}>
              <Icon
                style={{ color: 'red', marginRight: 7, fontSize: '16px' }}
                type="phone"
                theme="filled"
                rotate={90}
              />
              <span>
                Advies nodig? Bel ons op{' '}
                <a href='tel:+3236588245"' style={{ color: 'red' }}>{publicInformation.telefoonNummer}</a></span>
            </div>
          </Col>
          <Col lg={8}>
            <div style={{ textAlign: 'right' }}>
{/*              <a
                href="https://www.fietsenmintjens.be/e-bike-infoavonden/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginRight: 10 }}
              >
                E-bike info avonden
              </a>*/} {/* Corona Remove*/}
              <antd.Button
                type={'link'}
                onClick={()=>{console.log('clicked')
                  setModalVisible(true)}
                }
              >
                Contact
              </antd.Button>
            </div>
          </Col>
        </Row>

        <Row
          type="flex"
          justify="space-between"
          align="middle"
          style={{ paddingBottom: 30 }}
        >
          <Col xs={24} sm={24} md={8} lg={8}>
            <h2 
              style={{
                color: '#ee3143',
                cursor: 'pointer'
              }}
              onClick={() => {
                setSearchKeyword('')
                setDataSource([])
                navigate('/')
              }}
              >
                Categorieën
            </h2>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} style={{ display: 'flex', justifyContent: 'center' }}>
            <div className={HeaderComponentStyle.appLogoImage}>
              <Button
                type="link"
                style={{
                  width: '300px',
                  height: '80px',
                  padding: 0,
                  background: `url(${appConstants.frontEndEnvURL}/icons/fietslogo.svg) no-repeat center center / contain`,
                }}
                onClick={() => {
                  setSearchKeyword('')
                  setDataSource([])
                  navigate('https://fietsenmintjens.be')
                }}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            <div className={HeaderComponentStyle.searchInputWrapper}>
              <div className="global-search-wrapper" style={{ width: 300 }}>
                <AutoComplete
                  placeholder="Zoek fiets, merk, …."
                  className={'global-search'}
                  dataSource={dataSource.map(renderOption)}
                  onSearch={value => handleSearch(value)}
                  onSelect={value => handleSelect(value)}
                  optionLabelProp="text"
                  value={searchKeyword}
                  onInputKeyDown={(e)=>{if(e.keyCode === 13 && searchKeyword != ""){
                    handleSearchClick();
                    setSearchKeyword(searchKeyword)
                  }}}
                >
                  <Input
                    suffix={
                      <Button
                        className="search-btn"
                        style={{ marginRight: -12 }}
                        type="primary"
                        onClick={() => handleSearchClick()}
                      >
                        <Icon type="search" />
                      </Button>
                    }
                  />
                </AutoComplete>
              </div>
              <a
                href="https://fietsenmintjens.be/pages/locaties"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button type={'danger'}>
                  <img
                    style={{
                      width: '18px',
                      height: '18px',
                      marginRight: `${isSmallScreenForMobile ? 0 : '5px'}`,
                    }}
                    src={process.env.PUBLIC_URL + '/icons/locationIcons.png'}
                    alt={'Location Logo Not Found'}
                  />
                  {isSmallScreenForMobile ? '' : 'Winkelpunten'}
                </Button>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      {/*<Row type="flex" justify="center" className={AppStyle.appPrimaryColor}>
        <Container>
          <Row
            type="flex"
            justify="space-between"
            align="middle"
            style={{ height: 60 }}
          >
            <Col className={HeaderComponentStyle.contactIconWrapper}>
              <a href={'tel:+3236588245'}>
              <Icon
                style={{
                  color: 'white',
                  marginRight: 7,
                  cursor: 'pointer',
                  fontSize: '18px',
                }}
                type="phone"
                theme="filled"
                rotate={90}
              />
              </a>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ height: 60 }}
              className={HeaderComponentStyle.menuButtonWrapper}
            >
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.eBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  TriggerDropDownMenu(appConstants.bikesCategories.eBike.id)
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                E-Bikes
                <Icon type="caret-down" />
              </Button>
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.cityBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(`/products/${appConstants.bikesCategories.cityBike.id}`)
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                Stads- / Vrijetijdsfietsen
              </Button>
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.mountainBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(
                    `/products/${appConstants.bikesCategories.mountainBike.id}`
                  )
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                Mountainbikes
              </Button>
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.raceBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(`/products/${appConstants.bikesCategories.raceBike.id}`)
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                Racefietsen
              </Button>
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.vouwBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(`/products/${appConstants.bikesCategories.vouwBike.id}`)
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                Vouwfietsen
              </Button>
              <Button
                className={`${
                  isDropdownVisible &&
                  activeKey === appConstants.bikesCategories.kidsBike.id
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(`/products/${appConstants.bikesCategories.kidsBike.id}`)
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                {appConstants.bikesCategories.kidsBike.name}
              </Button>
              <Button
                className={`${
                  isDropdownVisible && activeKey === appConstants.accessories
                    ? HeaderComponentStyle.menuButtonWhite
                    : ''
                }`}
                onClick={() => {
                  navigate(
                    `/products/${appConstants.bikesCategories.accessoires.id}`
                  )
                }}
                style={{
                  height: '60px',
                  color: 'white',
                  fontSize: `${isSmallScreen ? '14px' : '18px'}`,
                }}
                type={'link'}
              >
                Accessoires
              </Button>
            </Col>
            <Col
              xs={2}
              sm={2}
              md={2}
              lg={2}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <HamburgerMenuComponent
                menuOpen={menuOpen}
                onClick={() => handleHamburgerMenuBtnClick()}
              />
            </Col>
          </Row>
        </Container>
      </Row>*/}

      {/* Responsive Menu Bar */}
      <div
        className={HeaderComponentStyle.menuList}
        style={{ height: menuOpen ? 250 : 0 }}
      >
        {menuOpen &&
          menuItems.map((item, index) => (
            <React.Fragment>
              <MenuItem
                key={index}
                delay={`${index * 0.1}s`}
                onClick={() => handleMenuItemClick(item)}
              >
                {item}
              </MenuItem>
            </React.Fragment>
          ))}
      </div>


      {!menuOpen && isDropdownVisible && (
        <MenuBarDropDownComponent
          listData={switchData()}
          onMenuItemClick={(header, text) =>
            handleDropDownMenuItemClick(header, text)
          }
        />
      )}
      <Modal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        closeIcon={false}
        footer={null}
        title={
          'Contacteert ons'
        }
      >
        <ContactUsModalForm setModalVisibility={setModalVisible}/>
      </Modal>
    </React.Fragment>
  )
}
